export default "__VITE_ASSET__56aa9c6f__"